<script setup>

</script>

<template>
  <div>

    <!-- head -->
    <div class="section section--head">
      <div class="container">
        <div class="row">
          <!-- title -->
          <div class="col-12 col-xl-10 offset-xl-1">
            <div class="section__title">
              <h1>AML Policy</h1>
            </div>
          </div>
          <!-- end title -->
        </div>
      </div>
    </div>
    <!-- end head -->

    <!-- article -->
    <div class="section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-xl-10 offset-xl-1">
            <div class="article">
              <!-- article content -->
              <div class="article__content">
                <p class="feature__title tw-text-left !tw-text-white">Anti-Money Laundering Policy</p>
                <p>In the Privacy Policy, HEXminer collects, uses, shares, and protects user information received through the website HEXminer.com. Any personal information collected from or provided by users (referred to as "you," "your," or "customers") will be processed by us. “Personal information” refers to any data, whether alone or combined with other information, that allows us to directly or indirectly identify you, such as email addresses, IP addresses, device identifiers, or other online identifiers. HEXminer uses the information collected about you solely to fulfill its contractual obligations and enhance customer service. This Privacy Policy, along with the Terms of Use and other referenced documents, defines the principles and rules governing how we collect, process, and use your personal data. Please read this document carefully to understand our policies regarding your personal data and how we will use it. If you do not wish for your personal information to be collected, you must stop using this website.  </p>
                <ol>

<!--                  <li>-->
<!--                    <h4>User rights</h4>-->
<!--                    <p class="tw-ml-[1rem]"></p>-->
<!--                    <ol></ol>-->
<!--                  </li>-->

                  <li>
                    <h4>User Information</h4>
                    <p class="tw-ml-[1rem]">We collect information generated from your interactions, including your email address, IP address, device identifiers, and other online identifiers. Each time you visit our website and use our services, we automatically collect the following information:  </p>
                    <p class="tw-ml-[1rem]">Your login details, browser type, operating system, platform, page interaction data, page response times, and data loading errors. </p>
                    <p class="tw-ml-[1rem]">This data is used to optimize the services and features of our platform, ensuring smooth operation.  </p>
                  </li>

                  <li>
                    <h4>How We Use Your Personal Information  </h4>
                    <p class="tw-ml-[1rem]">The information you provide may be used for the following purposes:</p>
                    <ol>
                      <li>Verifying and authenticating user identity for account setup and management to prevent fraud, deception, and other illegal activities.  </li>
                      <li>Complying with legal requirements related to anti-money laundering (AML) and combating the financing of terrorism (CFT).  </li>
                      <li>Notifying you about changes to our services.  </li>
                      <li>Managing the website and conducting internal operations, including troubleshooting, data analysis, testing, collecting statistics, and conducting surveys. </li>
                      <li>Ensuring the security of our website, services, and your account.  </li>
                      <li>Supporting, responding to, and resolving your complaints and issues related to the use of our services and website features.  </li>
                    </ol>
                    <p>It is important that your personal information is accurate and up to date. If your personal information changes, you must immediately correct your data or notify us for updates.  </p>
                  </li>

                  <li>
                    <h4>Use of Cookies</h4>
                    <p class="tw-ml-[1rem]">We use cookies stored on your device to help us identify you and provide a better service experience. Information collected from cookies may be used to evaluate website performance, identify issues, and optimize platform operations. We use this information to protect the security of the website and user accounts.  </p>
                  </li>

                  <li>
                    <h4>Disclosure of Personal Information  </h4>
                    <p class="tw-ml-[1rem]">We do not disclose your personal information to any unauthorized third parties. We only share relevant data with our partners, suppliers, and subcontractors when necessary to fulfill contractual obligations, optimize services, or comply with legal and regulatory requirements.</p>
                  </li>

                  <li>
                    <h4>Security and Storage of Personal Data  </h4>
                    <p class="tw-ml-[1rem]">We implement strict security measures to protect your personal information from loss, misuse, alteration, or disclosure. Only authorized personnel can access your data, and we ensure all information is handled according to the highest security standards.  </p>
                  </li>

                  <li>
                    <h4>Reasons for Processing Personal Data  </h4>
                    <p class="tw-ml-[1rem]">We ensure that your personal data is securely processed in accordance with this Privacy Policy and collected or used only when there is a legitimate basis to do so. </p>
                  </li>

                  <li>
                    <h4>User Rights</h4>
                    <p class="tw-ml-[1rem]">You have the right to request the deletion or modification of your personal data, restrict how it is processed, and object to its use for marketing purposes. If your information changes, please promptly update your account information. </p>
                  </li>

                  <li>
                    <h4>Anti-Money Laundering Mechanisms  </h4>
                    <p class="tw-ml-[1rem]">Users must not engage in any money laundering activities on the HEXminer platform. If suspicious activities related to money laundering are detected, they will be automatically processed by our AML system. In such cases, HEXminer may require you to provide relevant proof or take appropriate measures against the account upon confirmation of violations. Our system will automatically conduct checks to ensure the platform operates securely, legally, and in compliance with regulations.  </p>
                  </li>

                  <li>
                    <h4>Changes to the Privacy Policy  </h4>
                    <p class="tw-ml-[1rem]">HEXminer reserves the right to update this Privacy Policy at any time. All modifications will be published on this page and communicated to users via email. Please review this page periodically to stay informed of any changes.</p>
                  </li>

                </ol>
              </div>
              <!-- end article content -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end article -->

  </div>
</template>

<style scoped>

</style>
